var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "general-info" }, [
    _c("div", { staticClass: "general-info__header" }, [
      _vm.showIcon
        ? _c(
            "div",
            { staticClass: "general-info__icon-wrap" },
            [_vm._t("icon")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "general-info__title" }, [
        _vm._v(_vm._s(_vm.title))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "general-info__body" },
      [
        _c("img", {
          staticClass: "parking-details-card__logo",
          attrs: { src: _vm.imageUrl, alt: "location image" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "general-info__content" },
          _vm._l(_vm.items, function(row, index) {
            return _c("div", { key: index, staticClass: "general-info__row" }, [
              _c("span", { staticClass: "general-info__label" }, [
                _vm._v(_vm._s(row.label))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "general-info__value" }, [
                _vm._v(_vm._s(row.value))
              ])
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm._t("notes")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36e8124e", { render: render, staticRenderFns: staticRenderFns })
  }
}